import React from 'react';
import {
  Box,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

export type BulkUpdateMode = 'manual' | 'bulk-upload';

interface BulkUpdateModeSelectorProps {
  mode: BulkUpdateMode;
  onModeChange: (mode: BulkUpdateMode) => void;
}

const BulkUpdateModeSelector: React.FC<BulkUpdateModeSelectorProps> = ({
  mode,
  onModeChange,
}) => {
  return (
    <Card sx={{ mb: 3 }} data-testid='updateMethodSelectorCard'>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Choose Update Method
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select how you would like to perform bulk updates
        </Typography>
        
        <FormControl component="fieldset">
          <RadioGroup
            value={mode}
            onChange={(event) => onModeChange(event.target.value as BulkUpdateMode)}
          >
            <FormControlLabel
              value="manual"
              control={<Radio data-testid='manualStoreMethodSelect' />}
              label={
                <Box>
                  <Typography variant="subtitle1">Manual Store Selection</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Select stores individually and create operations manually
                  </Typography>
                </Box>
              }
            />            <FormControlLabel
              value="bulk-upload"
              control={<Radio data-testid='bulkUploadMethodSelect' />}
              label={
                <Box>
                  <Typography variant="subtitle1">Bulk Upload & Review</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Upload CSV files with pre-defined operations or review and process existing bulk jobs
                  </Typography>
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
};

export default BulkUpdateModeSelector;
